//文件管理

import { Table, Space, Button, Modal, Spin } from "antd"
import { downloadFileAPI, listFileAPI, deleteFileUrlByFileIdAPI } from "@/apis/file"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';

const FileManage = () => {

    const { t } = useTranslation();
    const power = useSelector(state => state.user.userInfo.power)

    const [loading, setLoading] = useState(false)
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    const [deleteFileId, setDeleteFileId] = useState('')

    const opts = {
        types: [
            {
                accept: {
                    'application/vnd.ms-excel': ['.xls'],
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
                        '.xlsx'
                    ]
                }
            },
            { description: 'CSV File', accept: { 'text/csv': ['.csv'] } }
        ]
    };

    const columns = [
        {
            title: t('FormList.FileName'),
            dataIndex: 'filename',
            key: 'filename',
        }, {
            title: t('FormList.Action'),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button onClick={() => downloadFile(record.filename)}>{t('ButtonList.Download')}</Button>
                    <Button style={{ display: power === 1 ? "none" : "block" }} danger onClick={() => showFileDeleteModel(record.id)}>
                        {t('ButtonList.Delete')}
                    </Button>
                </Space>
            )
        },
    ]

    const [fileList, setFileList] = useState([])

    useEffect(() => {
        const getFileList = async () => {
            const res = await listFileAPI()
            setFileList(res.data)
        }
        getFileList()
    }, [])

    const downloadFile = async (filename) => {
        const res = await downloadFileAPI(filename)
        const fileHandle = await window.showSaveFilePicker(opts);
        const writable = await fileHandle.createWritable({ keepExistingData: true }); // 创建可写入的文件对象
        await writable.write(res);
        await writable.close();
    }

    const showFileDeleteModel = (id) => {
        setIsDeleteModalOpen(true)
        setDeleteFileId(id)
    }
    const handleDeleteModalClose = () => {
        setIsDeleteModalOpen(false)
    }
    const handleDeleteModalOk = async () => {
        setIsDeleteModalOpen(false)
        setLoading(true)
        let res = await deleteFileUrlByFileIdAPI(deleteFileId)
        setLoading(false)
        window.location.reload();
    }

    return (
        <div align="center" gap="middle">
            <Spin spinning={loading} size="large" />
            <Modal
                open={isDeleteModalOpen}
                onOk={handleDeleteModalOk}
                onCancel={handleDeleteModalClose}
            >
                <p>是否删除该文件？</p>
            </Modal>
            <Table columns={columns} dataSource={fileList} rowKey={(record) => record.id}>
            </Table>
        </div>
    )
}

export default FileManage